import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppUtilService } from 'app/services/app-util.service';
import { AuthenticationService } from 'app/services/authentication.service';
import { PasswordService } from './services/password.service';
import { AppComponent } from './components/app.component';
import { AuthModule } from './modules/auth.module';
import { AppRoutingModule } from './routes/app.routing.module';
import { SummitNavModule } from '@summit/nav';
import { SummitApplicationListModule } from '@summit/application-list';
import {UtilMessageModule} from "@summit/utils";

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AuthModule,
        SummitNavModule,
        UtilMessageModule,
        SummitApplicationListModule], providers: [
        AuthenticationService,
        AppUtilService,
        PasswordService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
